import { css } from 'emotion';
import { space } from '@joykit';

export namespace styles {
  export const container = css({
    padding: '2rem 0',
    [`@media(min-width: 678px)`]: {
      maxWidth: '90vw',
      padding: space.squareInset.lg
    }
  });
}
